export default function ItemsToShow({ setItemsLimit, t, itemsLimit }) {

    function handleItemChange(e) {
        setItemsLimit(e.target.value);
        // Handle the selected value as needed
    }

    return (
        // <select className="form-control-sm border-0 col-1" aria-label="items to show" onChange={handleItemChange} >
        <select className="form-select form-select-sm col me-2" aria-label="items to show" onChange={handleItemChange} >
            <option defaultValue={itemsLimit}>{itemsLimit}</option>
            {/* <option defaultValue="">{t("Show")} {itemsLimit}</option> */}
            {/* <option defaultValue="">{t("Show")}</option> */}
            <option value="5">5</option>
            <option value="8">8</option>
            <option value="12">12</option>
            <option value="15">15</option>
        </select>
    )
}

export function ItemsToShowLibrary({ setItemsLimit, itemsLimit }) {

    function handleItemChange(e) {
        setItemsLimit(e.target.value);
        // Handle the selected value as needed
    }

    return (
        // <select className="form-control-sm border-0 col-1" aria-label="items to show" onChange={handleItemChange} >
        <select className="form-select form-select-sm col me-2" aria-label="items to show" onChange={handleItemChange} >
            <option defaultValue={itemsLimit}>{itemsLimit}</option>
            {/* <option defaultValue="">{t("Show")} {itemsLimit}</option> */}
            {/* <option defaultValue="">{t("Show")}</option> */}
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="30">30</option>
        </select>
    )
}